import { BackButton } from "@/common/components/BackButton";
import HelpButton from "@/common/components/HelpButton";
import { LogoIcon } from "@/common/components/icons";
import Header from "@/common/layout/Header";
export const NotFoundHeader = () => {
  return <Header className="border-b border-solid border-gray-200 pb-4" data-sentry-element="Header" data-sentry-component="NotFoundHeader" data-sentry-source-file="not-found-header.tsx">
      <BackButton data-sentry-element="BackButton" data-sentry-source-file="not-found-header.tsx" />
      <div className="mx-auto flex  items-center">
        <LogoIcon data-sentry-element="LogoIcon" data-sentry-source-file="not-found-header.tsx" />
      </div>
      <div className="flex items-center justify-end">
        <HelpButton data-sentry-element="HelpButton" data-sentry-source-file="not-found-header.tsx" />
      </div>
    </Header>;
};